module.exports = __webpack_public_path__ + "img/coolant-temp-cool.c5d738f6.svg";